import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import cn from "classnames";
import styles from "./styles.module.scss";
import { track } from "../../utils/amplitude";
import { RoutesPaths } from "../../shared/paths.config";

const noFooter = [
  "/blog/subscription-app-launch-checklist",
  "/blog/growth-cases-for-subscription-apps",
];

const Footer = () => {
  const router = useRouter();

  if (router.pathname === RoutesPaths.FLOW) {
    return null;
  }

  const getFooterStyles = () => {
    if (noFooter.includes(router.pathname)) {
      return { marginTop: 0 };
    }
  };

  return (
    <div
      className={
        router.pathname === "/development"
          ? `${styles.footer} ${styles.footer_alt}`: router.pathname === "/win-back-refunds"? `${styles.footer} ${styles.footer_no_margin}`
          : styles.footer
      }
      style={getFooterStyles()}
    >
      <div className={cn("container", styles.list)}>
        <div className={styles.item}>
          <strong>Product</strong>

          <Link href="/development">Apphud for development</Link>
          <Link href="/marketing">Apphud for marketing</Link>
          <Link href="/product">Apphud for product</Link>
          <Link href="/paywalls">Paywall screens (new!)</Link>
          <Link href="/flows">Flows</Link>
          <Link href="/integrations">Integrations</Link>
          <Link href="/pricing">Pricing</Link>
        </div>

        <div className={styles.item}>
          <strong>Services</strong>
          <Link href="/apple-receipt-checker">Apple Receipt Checker</Link>
          <Link href="/apple-fiscal-calendar-2025">
            Apple’s Fiscal Calendar
          </Link>
          <Link href="/gallery">Paywalls Gallery</Link>
          <Link href="/subscription-app-revenue-calculator">
            Subscription App Revenue Calculator
          </Link>
        </div>

        <div className={styles.item}>
          <strong>Resources</strong>
          <Link
            onClick={() =>
              track("footer_external_link_clicked", {
                target_url: "https://blog.apphud.com",
              })
            }
            href="/blog"
          >
            Blog
          </Link>
          <a href="https://docs.apphud.com"></a>
          <a
            onClick={() =>
              track("footer_external_link_clicked", {
                target_url: "https://docs.apphud.com",
              })
            }
            href="https://docs.apphud.com"
          >
            Documentation
          </a>
          <Link href="https://careers.apphud.com">Careers</Link>
          <Link href="/contact">Contact us</Link>
          <Link href="/about">About us</Link>
        </div>

        <div className={styles.item}>
          <strong>Compare</strong>
          <Link href="/in-house">Apphud vs in-house</Link>
          <Link href="/revenuecat">Apphud vs RevenueCat</Link>
          <Link href="/compare-apphud-to-adapty">Apphud vs Adapty</Link>
        </div>
        <div className={styles.item}>
          <strong>Legal</strong>
          <a
            onClick={() =>
              track("footer_external_link_clicked", {
                target_url: "https://legal.apphud.com/terms",
              })
            }
            href="https://legal.apphud.com/terms"
          >
            Terms
          </a>
          <a
            onClick={() =>
              track("footer_external_link_clicked", {
                target_url: "https://legal.apphud.com/privacy",
              })
            }
            href="https://legal.apphud.com/privacy"
          >
            Privacy
          </a>

          <Link href="/data-protection">Data Protection</Link>
        </div>

        <div className={styles.item}>
          <strong>Links</strong>

          <a
            href="https://status.apphud.com"
            onClick={() =>
              track("footer_external_link_clicked", {
                target_url: "https://status.apphud.com",
              })
            }
          >
            System status
          </a>
          <a
            href="https://facebook.com/apphud"
            onClick={() =>
              track("footer_external_link_clicked", {
                target_url: "https://facebook.com/apphud",
              })
            }
          >
            Facebook
          </a>
          <a
            href="https://twitter.com/apphud"
            onClick={() =>
              track("footer_external_link_clicked", {
                target_url: "https://twitter.com/apphud",
              })
            }
          >
            Twitter
          </a>
          <a
            href="https://www.crunchbase.com/organization/apphud"
            onClick={() =>
              track("footer_external_link_clicked", {
                target_url: "https://www.crunchbase.com/organization/apphud",
              })
            }
          >
            Crunchbase
          </a>
          <a
            href="https://angel.co/company/apphud"
            onClick={() =>
              track("footer_external_link_clicked", {
                target_url: "https://angel.co/company/apphud",
              })
            }
          >
            AngelList
          </a>
          <a
            href="https://linkedin.com/company/apphud"
            onClick={() =>
              track("footer_external_link_clicked", {
                target_url: "https://linkedin.com/company/apphud",
              })
            }
          >
            LinkedIn
          </a>
          <a
            href="https://github.com/apphud"
            onClick={() =>
              track("footer_external_link_clicked", {
                target_url: "https://github.com/apphud",
              })
            }
          >
            GitHub
          </a>
          <a href="/for-investors">For investors</a>
        </div>
      </div>
      <div className={cn("container", styles.logo)}>
        <Link href="/">
          <a>
            <svg
              width="120"
              height="27"
              viewBox="0 0 120 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 22.5846C14.2992 22.5846 16.3873 21.6807 17.9283 20.209L11.9889 14.3816L6.00463 20.1442C7.55187 21.6542 9.66728 22.5846 12 22.5846ZM13.4272 11.0081L19.9019 17.3606C20.3414 16.3285 20.5846 15.1926 20.5846 14C20.5846 9.25885 16.7412 5.41538 12 5.41538C7.25885 5.41538 3.41538 9.25885 3.41538 14C3.41538 15.1593 3.64517 16.2649 4.06167 17.2737L10.5821 10.9948C11.3778 10.2286 12.6387 10.2345 13.4272 11.0081ZM12 26C18.6274 26 24 20.6274 24 14C24 7.37258 18.6274 2 12 2C5.37258 2 0 7.37258 0 14C0 20.6274 5.37258 26 12 26ZM88.0243 8.67214C87.1763 7.69614 86.0163 7.20814 84.5443 7.20814C82.9923 7.20814 81.6883 7.71214 80.6323 8.72014V2.84014H77.1283V20.4801H80.6323V13.6641C80.6323 12.6241 80.8963 11.8001 81.4243 11.1921C81.9523 10.5841 82.6563 10.2801 83.5363 10.2801C84.3204 10.2801 84.8883 10.5201 85.2403 11.0001C85.6083 11.4801 85.7923 12.2081 85.7923 13.1841V20.4801H89.2963V12.6081C89.2963 10.9601 88.8723 9.64814 88.0243 8.67214ZM42.8393 7.49615H40.2233L39.8393 8.74414C38.6553 7.68814 37.2393 7.16014 35.5913 7.16014C33.6393 7.16014 32.0153 7.80814 30.7193 9.10414C29.4393 10.4001 28.7993 12.0241 28.7993 13.9761C28.7993 15.9441 29.4393 17.5841 30.7193 18.8961C32.0153 20.1921 33.6393 20.8401 35.5913 20.8401C37.2073 20.8401 38.6073 20.3281 39.7913 19.3041L40.0793 20.4561H42.8393V7.49615ZM35.8553 17.5281C34.8473 17.5281 34.0073 17.1921 33.3353 16.5201C32.6793 15.8481 32.3513 15.0001 32.3513 13.9761C32.3513 13.3041 32.5033 12.7041 32.8073 12.1761C33.1113 11.6321 33.5273 11.2081 34.0553 10.9041C34.5993 10.5841 35.2073 10.4241 35.8793 10.4241C36.8873 10.4241 37.7273 10.7601 38.3993 11.4321C39.0713 12.1041 39.4073 12.9521 39.4073 13.9761C39.4073 15.0001 39.0713 15.8481 38.3993 16.5201C37.7273 17.1921 36.8793 17.5281 35.8553 17.5281ZM57.5376 9.10414C56.2576 7.80814 54.6416 7.16014 52.6896 7.16014C51.0736 7.16014 49.6896 7.67214 48.5376 8.69614L47.9376 7.52014H45.6096V25.1601H49.1136V19.7841C50.1696 20.5041 51.3616 20.8641 52.6896 20.8641C54.6256 20.8641 56.2416 20.2161 57.5376 18.9201C58.8336 17.6081 59.4816 15.9681 59.4816 14.0001C59.4816 12.0321 58.8336 10.4001 57.5376 9.10414ZM52.3776 17.5521C51.3696 17.5521 50.5296 17.2161 49.8576 16.5441C49.2016 15.8721 48.8736 15.0241 48.8736 14.0001C48.8736 13.3281 49.0176 12.7201 49.3056 12.1761C49.6096 11.6321 50.0336 11.2081 50.5776 10.9041C51.1216 10.6001 51.7296 10.4481 52.4016 10.4481C53.0736 10.4481 53.6736 10.6001 54.2016 10.9041C54.7456 11.2081 55.1696 11.6321 55.4736 12.1761C55.7776 12.7201 55.9296 13.3281 55.9296 14.0001C55.9296 15.0241 55.5936 15.8721 54.9216 16.5441C54.2496 17.2161 53.4016 17.5521 52.3776 17.5521ZM68.449 7.16014C70.401 7.16014 72.017 7.80814 73.297 9.10414C74.593 10.4001 75.241 12.0321 75.241 14.0001C75.241 15.9681 74.593 17.6081 73.297 18.9201C72.001 20.2161 70.385 20.8641 68.449 20.8641C67.121 20.8641 65.929 20.5041 64.873 19.7841V25.1601H61.369V7.52014H63.697L64.297 8.69614C65.449 7.67214 66.833 7.16014 68.449 7.16014ZM65.617 16.5441C66.289 17.2161 67.129 17.5521 68.137 17.5521C69.161 17.5521 70.009 17.2161 70.681 16.5441C71.353 15.8721 71.689 15.0241 71.689 14.0001C71.689 13.3281 71.537 12.7201 71.233 12.1761C70.929 11.6321 70.505 11.2081 69.961 10.9041C69.433 10.6001 68.833 10.4481 68.161 10.4481C67.489 10.4481 66.881 10.6001 66.337 10.9041C65.793 11.2081 65.369 11.6321 65.065 12.1761C64.777 12.7201 64.633 13.3281 64.633 14.0001C64.633 15.0241 64.961 15.8721 65.617 16.5441ZM102.223 19.2561C101.119 20.3121 99.6473 20.8401 97.8074 20.8401C95.9833 20.8401 94.5113 20.3041 93.3913 19.2321C92.2873 18.1601 91.7353 16.7521 91.7353 15.0081V7.52014H95.2393V14.6001C95.2393 15.5281 95.4633 16.2561 95.9114 16.7841C96.3754 17.2961 97.0073 17.5521 97.8074 17.5521C98.6234 17.5521 99.2553 17.2961 99.7034 16.7841C100.167 16.2561 100.399 15.5281 100.399 14.6001V7.52014H103.903V15.0081C103.903 16.7681 103.343 18.1841 102.223 19.2561ZM119.523 2.84014H116.019V8.21614C114.963 7.51214 113.779 7.16014 112.467 7.16014C111.171 7.16014 110.003 7.45614 108.963 8.04814C107.923 8.64014 107.107 9.45614 106.515 10.4961C105.939 11.5361 105.651 12.7041 105.651 14.0001C105.651 15.2961 105.939 16.4721 106.515 17.5281C107.107 18.5681 107.923 19.3841 108.963 19.9761C110.003 20.5681 111.171 20.8641 112.467 20.8641C114.019 20.8641 115.371 20.3761 116.523 19.4001L116.931 20.4801H119.523V2.84014ZM112.731 17.5521C111.723 17.5521 110.883 17.2161 110.211 16.5441C109.539 15.8721 109.203 15.0241 109.203 14.0001C109.203 12.9761 109.539 12.1281 110.211 11.4561C110.883 10.7841 111.723 10.4481 112.731 10.4481C113.755 10.4481 114.603 10.7841 115.275 11.4561C115.947 12.1281 116.283 12.9761 116.283 14.0001C116.283 15.0081 115.947 15.8561 115.275 16.5441C114.603 17.2161 113.755 17.5521 112.731 17.5521Z"
                fill="white"
              />
            </svg>
          </a>
        </Link>
        <span>Copyright © {new Date().getFullYear()}</span>
      </div>
    </div>
  );
};

export default Footer;
